import React, { useState, useEffect, useCallback } from 'react';
import "./NewDesign/Styles/NavBar.css";
import { useNavigate } from 'react-router-dom';

import logo from './NewDesign/Photos/logo2.png'

function NavBar({ showMainNav = true }) {
  const Navigate = useNavigate();

 
  const [LowerBlock, setLowerBlock] = useState(window.innerWidth <= 950 ? true : false);
  const [BurgerMenu, setBurgerMenu] = useState(false);

  const [BurgerSpecific, setBurgerSpecific] = useState(window.innerWidth <= 950 ? true : false);



  useEffect(() => {
    const faceArray = ["https://static.yomecontrolo.cl/public/icons/ymc-loading.gif"]
    //preloading image
    faceArray.forEach((face) => {
      const img = new Image();
      img.src = face;
    });
  }, []);



  function ToggleNavbarDisplay() {
    let x = document.getElementById("NavbarBurgerIcon")
    x.classList.toggle("change");
    if(BurgerMenu) {
      setBurgerMenu(false)
    } else {
      setBurgerMenu(true)
    }
  }

  const HandleLowerBlock = useCallback(() => {
    if(window.innerWidth <= 950) {
      setLowerBlock(true)
      setBurgerSpecific(true)
    } else {
      setLowerBlock(false)
      setBurgerSpecific(false)
      setBurgerMenu(false)
    }
  },[])

  const hideUpperBar = useCallback(() => {
    let currentScrollPos = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (!currentScrollPos) {
      document.getElementById("navbar").style.top = "0";
    } else {
      document.getElementById("navbar").style.top = "-30px";
    }
  },[])

  useEffect(() => {
    window.addEventListener("resize", HandleLowerBlock);
    return () => window.removeEventListener("resize", HandleLowerBlock);
  }, [HandleLowerBlock]);

  useEffect(() => {
    window.addEventListener("scroll", hideUpperBar);
    return () => window.removeEventListener("scroll", hideUpperBar);
  }, [hideUpperBar]);

  return (
    <div className='NavbarFull' id="navbar">
      <div className='NavbarPurpleUpBar'>
        <div className='NavbarPurpleUpBarInner'>
                    <div className='NavbarPurpleUpBarInnerButton'><a href='https://empresas.ymc.cl' target="_blank" rel="noreferrer" style={{textDecoration:"none",color:"white"}}>Empresas</a></div>
          <div className='NavbarPurpleUpBarInnerButton NavInnerSelected' onClick={() => Navigate("/")}>APS - Personas</div>
{/*         <div className='NavbarPurpleUpBarInnerButton'>Empresas</div>
          <div className='NavbarPurpleUpBarInnerButton'>Personas</div> */}
        </div>
      </div>
      {showMainNav ? <div className="NavbarFullBackGradient">
      <div className={LowerBlock && BurgerMenu ? "NavbarFullInner NavbarMenuOpen" : "NavbarFullInner"}>
        <div className="NavbarFullInnerLeftSide">
          <img src={logo} className="NavbarFullInnerLeftSideLogoYMC" alt="logo" onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/")}} />
        </div>
        <div className="NavbarFullInnerMiddleButtons">
          <div className='NavbarFullInnerMiddleIndividualButton' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/")}}>Inicio</div>

          <div className='NavbarFullInnerMiddleIndividualButton' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/quienes-somos")}}>Nosotros</div>
          <div className='NavbarFullInnerMiddleIndividualButton' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; setBurgerMenu(false); Navigate("/contacto")}}>Contacto</div>
        </div>
        <div className="NavbarFullInnerRightSide">
       
          {BurgerSpecific ?
          <div className="NavbarFullInnerRightSideBurgerIcon" id="NavbarBurgerIcon" onClick={() => ToggleNavbarDisplay()}>
            <div className="NavbarBurgerIconBar3"></div>
            <div className="NavbarBurgerIconBar1"></div>
            <div className="NavbarBurgerIconBar2"></div>
          </div>
          : null}
        </div>
      </div>
      {LowerBlock && BurgerMenu ?
      <div className="NavbarLowerBlockOptions">
        <div className="NavbarLowerBlockOptionsWhiteBox">
          {!document.URL.includes("encuesta-bienvenida") ?
          <>
          <div className='NavbarLowerBlockOptionsIndividualButton' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/")}}>Inicio</div>

          <div className='NavbarLowerBlockOptionsIndividualButton' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/quienes-somos")}}>Nosotros</div>
          <div className='NavbarLowerBlockOptionsIndividualButton' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; setBurgerMenu(false); Navigate("/contacto")}}>Contacto</div>
          </>
          : null}
         
        </div>
      </div>
      : null }
      </div>
      : null}
    </div>
  );
}

export default NavBar;